import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" toastOptions={{
        style: {
          background: '#1E1C19',
          color: '#F4EFE4',
          border: '1px solid #1E1C19',
          borderRadius: 2,
          fontFamily: "'DM Sans', sans-serif",
        }
      }} />
    </div>
  );
}

export default App;
